import sanitizeHTML from "../../../utils/sanitiseHTML";

const FeesCalculate = ({ data }) => {
  return (
    <div className="section__fees-calculate">
      <h2>{data.title}</h2>
      <div className="section__fees-calculate__wrapper">
        {data.process &&
          data.process.map(({ image, heading, description }) => (
            <div className="section__fees-calculate__child">
              <div className="section__fees-calculate__child__inner-left">
                <img
                  className="section__fees-calculate__child__inner_img"
                  data-src={image && image.sourceUrl ? image.sourceUrl : ''}
                  alt="consultations-image"
                  width={96}
                  height="auto"
                />
              </div>
              <div className="section__fees-calculate__child__inner-right">
                <h5>{heading}</h5>
                <p dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }} />
              </div>
            </div>
          ))}
        <p
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(data.bottomDescription),
          }}
        />
      </div>
    </div>
  );
};

export default FeesCalculate;
